"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _illustrations = require("../shared/illustrations");
var _jsxRuntime = require("react/jsx-runtime");
var Illustration = function Illustration(_ref) {
  var illustration = _ref.illustration;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: _illustrations.illustrations[illustration]
  });
};
Illustration.defaultProps = {};
var _default = exports.default = Illustration;